import React, {Component} from 'react'
import debounce from 'lodash/debounce'
import find from 'lodash/find'
import config from './config'
import partyColorMap from './partyColorMap'
import {ELECTIONS} from './elections'

const electionStageLegend = [
  {label: "पहिलो चरण (मङ्सिर १०)", color: "#9FA8DA"},
  {label: "दोश्रो चरण (मङ्सिर २१)", color: "#3F51B5"},
  {label: "संरक्षित क्षेत्र", color: "#37474f"}
]

const zoomInControlStyle = {
  textDecoration: 'none',
  padding: '2px 8px',
  backgroundColor: 'white',
  fontSize: 12,
  border: '1px solid #3F51B5',
  borderRadius: 0,
  borderTopLeftRadius: 4,
  borderBottomLeftRadius: 4,
  outline: "none",
  cursor: 'pointer'
}

const zoomOutControlStyle = {
  textDecoration: 'none',
  padding: '2px 8px',
  backgroundColor: 'white',
  fontSize: 12,
  border: '1px solid #3F51B5',
  borderLeft: 0,
  borderRight: 0,
  borderRadius: 0,
  outline: "none",
  cursor: 'pointer'
}

const zoomResetControlStyle = {
  textDecoration: 'none',
  padding: '2px 8px',
  backgroundColor: 'white',
  fontSize: 12,
  border: '1px solid #3F51B5',
  borderRadius: 0,
  borderTopRightRadius: 4,
  borderBottomRightRadius: 4,
  outline: "none",
  cursor: 'pointer'
}
const base_url = config.base_url

class MainMapComponent extends Component {
  
    state = {
      boundary : "province",
      zoom: 1,
      loaded: false,
      regionData: null,
      regionBoundary: null,
      districtBoundaryData: null,
      countData: null
    }
  
    componentWillReceiveProps = (newProps) => {
      if(newProps.election != "parliament") {
        this.setState({boundary: 'province'})
      }

      if(newProps.election != this.props.election) {
        this.setState({loaded: false})
        Promise.all([
          fetch(`${base_url}/${newProps.election}.json`).then(r => r.json()),
          fetch(`${base_url}/${newProps.election == "parliament" ? "province":"districts/"+newProps.election}.json`).then(r => r.json()),
          fetch(`${config.api_base_url}/embed/${find(ELECTIONS, {key: newProps.election}).province}`).then(r => r.json()),
        ]).then((results) => {
          this.setState({
            regionData: results[0],
            regionBoundary: results[1],
            loaded: true,
            countData: results[2].data,
          }, () => {
            this.drawMap()
          })
        })
      }
    }
  
    componentDidMount() {
      Promise.all([
        fetch(`${base_url}/parliament.json`).then(r => r.json()),
        fetch(`${base_url}/province.json`).then(r => r.json()),
        fetch(`${base_url}/district.json`).then(r => r.json()),
        fetch(`${config.api_base_url}/embed/${find(ELECTIONS, {key: this.props.election}).province}`).then(r => r.json()),
      ]).then((results) => {
        this.setState({
          regionData: results[0],
          regionBoundary: results[1],
          districtBoundaryData: results[2],
          loaded: true,
          countData: results[3].data,
        }, () => {
          this.drawMap()
        })
      })
      
    }
  
    componentDidUpdate() {
      this.drawMap()
    }
  
    handleRegionClick = (data) => {
      // this.props.uistore.setZoom(1)
      this.props.onRegionClick(data.properties)
    }
  
    drawMap = () => {
      const {boundary, loaded, regionData, regionBoundary, districtBoundaryData, countData} = this.state;
      const {width, height} = this.props;
  
      if(!loaded || !this.container) return;
      let reloading = true;
  
      this.container.innerHTML = ''
      let zooming = false;
  
      const projection = d3.geo.mercator()
        .precision(0)
        .scale(1)
        .translate([0, 0]);
      
      const path = d3.geo.path().projection(projection);
  
      const svg = d3.select(this.container)
        .append("svg")
        .attr("width", width)
        .attr("height", height);
  
      const bounds = path.bounds(regionData);
      const scale  = Math.round(.95 / Math.max((bounds[1][0] - bounds[0][0]) / width, (bounds[1][1] - bounds[0][1]) / height));
      const transl = [(width - scale * (bounds[1][0] + bounds[0][0])) / 2, (height - scale * (bounds[1][1] + bounds[0][1])) / 2];
      let initialTranslate;
  
      const tip = d3.tip().attr('class', 'd3-tip').html((d) => d.properties.name);
  
      const zoomScale = d3.scaleLinear().domain([1, 14]).range([scale, 8 * scale])
  
      projection.scale(zoomScale(1)).translate(transl);
      // projection.scale(zoomScale(this.props.uistore.zoom)).translate(transl);
  
      svg.append("rect")
        .attr("class", 'background')
        .attr("width", width)
        .attr("height", height)
        .style('cursor', '-webkit-grab')
        .attr('fill', 'none')
        .attr('pointerEvents', 'all')
        .call(tip);
  
      const g = svg.append("g");
  
      const defaultColor = (d) => {
        if (d.properties.phase == 0){
          return "#37474F"
        }

        const candidate = find(countData, {region: d.properties.id});

        if(!candidate) {
          return "#C5CAE9"
        }

        let variant = "lead"
        if(candidate.won) {
          variant = "won"
        }

        const color = find(partyColorMap, {id: Number(candidate.party)})

        if(color) {
          return color[variant]
        } 

        return partyColorMap[5][variant]

        if(d.properties.phase == 1) {
          return "#9FA8DA";
        }else if (d.properties.phase == 0){
          return "#37474F"
        }else {
          return "#7986CB"
        }
      }
  
      const hoverColor = (d) => {
        if(d.properties.phase == 1) {
          return "#5C6BC0";
        }else if (d.properties.phase == 0){
          return "#37474F"
        }else {
          return "#3F51B5"
        }
      }
  
      // main regions
      g.append("g")
      .attr("id", "states")
      .selectAll("path")
      .data(regionData.features)
      .enter()
        .append("path")
        .attr("d", path)
        .style("fill", defaultColor)
        .style("stroke-width", "0.5px")
        .style("stroke", "white")
        .style('cursor', '-webkit-grab')
        .style("stroke-dasharray", "1, 4")
        .on("click", (d) => {
          if(zooming) {
            // zooming = false;
            return
          };
          
          this.handleRegionClick(d)
        })
        .on('mouseenter', function(d, i){
          d3.select(this).style('fill', defaultColor);
          if(!reloading) {
            tip.show(d, i);
          }
          
        })
        .on('mouseleave', function(d, i) {
          d3.select(this).style('fill', defaultColor);
          tip.hide(d, i);
        });
  
      //render boundaries
      g.append("g")
        .attr("id", "provinces")
        .selectAll("path")
        .data(boundary == "province" ? regionBoundary.features : districtBoundaryData.features)
        // .data(provinceFetch.value.features)
        .enter()
          .append("path")
          .attr("d", path)
          .style("fill", 'transparent')
          // .style("fill", defaultColor)
          .style("pointer-events", "none")
          .style("stroke-width", "1px")
          .style("stroke", 'white');
  
      //label
      const labels = g.append('g').attr('class', 'labels');
  
      labels.selectAll('.label')
        .data(boundary == "province" ? regionBoundary.features : districtBoundaryData.features)
        .enter().append('text')
        .style("font-size", '13px')
        .style("fill", 'white')
        .style("text-shadow", '1px 1px black')
        .style("pointer-events", 'none')
        .attr('transform', function(d) {
            return "translate(" + path.centroid(d) + ")";
        })
        .style('text-anchor', 'middle')
        .text(function(d) {
            return d.properties.name
        });
  
      // legend texts
      
      const legendBox = g.append('g')
      .attr('class', 'legendbox')
      .attr('transform',(d, i) => `translate(${[width - 150, 10]})`);

      legendBox.append('rect')
      .attr('fill', '#E8EAF6')
      .attr('height', 130)
      .attr('width', 150);

      const legendGroups = legendBox.selectAll('.legendGroup')
      .data(partyColorMap)
      .enter()
      .append('g')
      .attr('transform', (d,i) => `translate(0, ${i * 20 + 20})`)

      legendGroups
      .append('text')
      .text((d) => d.label)
      .attr('transform', 'translate(8,0)')
      .style('font-size', '12px')

      legendGroups
      .append('rect')
      .attr('height', 10)
      .attr('width', 10)
      .attr('transform', 'translate(55,-9)')
      .style('fill', d => d.lead)

      legendGroups
      .append('text')
      .text("अग्र")
      .attr('transform', 'translate(68,0)')
      .style('font-size', '12px')

      legendGroups
      .append('rect')
      .attr('height', 10)
      .attr('width', 10)
      .attr('transform', 'translate(95,-9)')
      .style('fill', d => d.won)

      legendGroups
      .append('text')
      .text("विजयी")
      .attr('transform', 'translate(110,0)')
      .style('font-size', '12px')

      // legendBox
      // .selectAll('.legendGroup')
      // .selectAll('legend')
      // .enter()
      // .append()
  
      /*
      const legendTexts = legendBox.append('g').attr('class', 'labels').attr('x', 0).attr('y', 0);
      legendTexts.selectAll('.legendText').data(partyColorMap)
      .enter().append('text')
      .attr("class", 'legendtext')
      .attr('transform',(d, i) => `translate(${[0, i * 20 + 20]})`)
      // .attr("x", (d, i) => width - 120)
      // .attr("y", (d, i) => 15 * (i + 1))
      .text((d) => d.label)
      .style('font-size', '12px')
      .style('text-align', 'right')
      
      // legend colors
      const leadingBoxes = legendBox.append('g').attr('class', 'labels').attr('x', 0).attr('y', 0);
      leadingBoxes.selectAll('.legendColor').data(partyColorMap)
      .enter().append('rect')
      .attr('height', 10)
      .attr('width', 10)
      .attr('fill', (d) => d.lead)
      .attr('transform',(d, i) => `translate(${[width - 150 + 55, i * 20 + 20]})`)
      // .attr("x", (d, i) => width - 135)
      // .style('font-size', '12px')
      .attr("y", (d, i) => 15 * i + 6)

      // legend colors
      const winningBoxes = legendBox.append('g').attr('class', 'labels').attr('x', 0).attr('y', 0);
      winningBoxes.selectAll('.legendColor').data(partyColorMap)
      .enter().append('rect')
      .attr('height', 10)
      .attr('width', 10)
      .attr('fill', (d) => d.won)
      .attr("x", (d, i) => width - 135)
      .style('font-size', '12px')
      .attr("y", (d, i) => 15 * i + 6)
  
      */

      // copy notice
      g.append('g')
      .attr('class', 'legendbox')
      .append('text')
      .text("© Copyright PahiloPost")
      .attr("x", 5)
      .style('font-size', '12px')
      .attr("y", height - 50)
      .attr('fill', "#212121")

      g.append('g')
      .attr('class', 'legendbox')
      .append('text')
      .text("नक्सालाई क्लिक गरी सार्न सकिन्छ")
      .attr("x", 5)
      .style('font-size', '12px')
      .attr("y", height - 70)
      .attr('fill', "#212121");
    
      const zoomed = () => {
        const zt = zoom.translate()
        const zs = zoom.scale()
  
        let t = [
          (width - zs * (bounds[1][0] + bounds[0][0])) / 2, 
          (height - zs * (bounds[1][1] + bounds[0][1])) / 2
        ];

        
        projection
        .translate([t[0] + zt[0]/2, t[1] + zt[1]/2]) //
        .scale(zs);
  
        g.selectAll("path")
          .attr("d", path);
        
        labels.selectAll('text').attr('transform', function(d) {
          return "translate(" + path.centroid(d) + ")";
        })
      }
  
      const zoom = d3.behavior.zoom()
        .on("zoom", zoomed)
        .on('zoomstart', () => {zooming = true; })
        .on('zoomend', () => {zooming = false; })
        .scale(zoomScale(1))
        .scaleExtent([scale, 8 * scale])
        ;
  
      initialTranslate = zoom.translate();
      svg
        .call(zoom)
        .call(zoom.event)
        .on("wheel.zoom", null);
  
      if(this.resetButton) {
        this.resetButton.addEventListener('click', (e) => {
          e.preventDefault();
  
          zoom.scale(scale).translate(initialTranslate)
          projection
          .translate(initialTranslate)
          .scale(scale);
          svg.call(zoom.event);
  
        })
  
        this.zoomInButton.addEventListener('click', debounce(() => {
          
          const zs = zoomScale(zoomScale.invert(zoom.scale()) + 1) // zoom.scale() + 3000
          zoom.scale(zs)
  
          svg.call(zoom.event);
        }, 100))
  
        this.zoomOutButton.addEventListener('click', debounce(() => {
          
          const zs = zoomScale(zoomScale.invert(zoom.scale()) - 1)
          zoom.scale(zs)
  
          svg.call(zoom.event);
  
        }, 100))
      }
  
      reloading = false;
    }
  
    handleBoundaryChange = (e) => {
      this.setState({boundary: e.target.value})
    }
  
    renderBoundaryControl = () => {
      if (this.props.election != "parliament") return;
  
  
      return (
        <div className="boundaryControls">
          {/* <FormControlLabel value="male" control={<Radio value="province" name="boundary_type" onClick={this.handleBoundaryChange} checked={this.state.boundary == "province"} />} label="प्रदेश सिमा" />
          <FormControlLabel value="female" control={<Radio value="district" name="boundary_type" onClick={this.handleBoundaryChange} checked={this.state.boundary == "district"} />} label="जिल्ला सिमा" /> */}
        </div>
      )
    }
  
    render() {
      const {height, width} = this.props;
      
      if(!this.state.loaded) {
        return (
          <div style={{width, height, textAlign: 'center'}}>
            <p>Loading...</p>
          </div>
        )
      }else {
        return (
          <div style={{position: 'relative'}}>
            <div ref={(c) => this.container = c}></div>
            {this.renderBoundaryControl()}
            <div style={{position: 'absolute', bottom: 10, left: 4}}>
              <button style={zoomInControlStyle} ref={(c) => {this.zoomInButton = c;}} type="button" >zoom in</button>
              <button style={zoomOutControlStyle} ref={(c) => {this.zoomOutButton = c;}} type="button" >zoom out</button>
              <button style={zoomResetControlStyle} ref={(c) => {this.resetButton = c;}} type="button">reset</button>
            </div>
          </div>
        )
      }
    }
  }
  
  export default MainMapComponent;


// WEBPACK FOOTER //
// ./src/MainMapComponent.js